<div class="box">
	<i class="fa fa-close-round box__icon"></i>
	<div class="box__info">
		<p><ng-content></ng-content></p>
	</div>
</div>
